// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS variables. */
:root {
	--PhoneInput-color--focus: #03b2cb;
	--PhoneInputInternationalIconPhone-opacity: 0.8;
	--PhoneInputInternationalIconGlobe-opacity: 0.65;
	--PhoneInputCountrySelect-marginRight: 0.35em;
	--PhoneInputCountrySelectArrow-width: 0.3em;
	--PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);
	--PhoneInputCountrySelectArrow-borderWidth: 1px;
	--PhoneInputCountrySelectArrow-opacity: 0.45;
	--PhoneInputCountrySelectArrow-color: currentColor;
	--PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);
	--PhoneInputCountrySelectArrow-transform: rotate(45deg);
	--PhoneInputCountryFlag-aspectRatio: 1.5;
	--PhoneInputCountryFlag-height: 1em;
	--PhoneInputCountryFlag-borderWidth: 1px;
	--PhoneInputCountryFlag-borderColor: rgba(0,0,0,0.5);
	--PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);
	--PhoneInputCountryFlag-backgroundColor--loading: rgba(0,0,0,0.1);
}

.DWXlZA4qJECCe03PnK8T {
	/* This is done to stretch the contents of this component. */
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}

.C92DdxhbHyjHpBwTDvGU {
	/* The phone number input stretches to fill all empty space */
	-webkit-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	/* The phone number input should shrink
	   to make room for the extension input */
	min-width: 0;
}

.Fst2Kt2IICGHH5VFs2Xa {
	width: calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));
	height: var(--PhoneInputCountryFlag-height);
}

.NCiLa8ZsrVsUC76LuiWY {
	width: var(--PhoneInputCountryFlag-height);
}

.TB2QPWXJ6fToD3uCXjC0 {
	/* Removed \`background-color\` because when an \`<img/>\` was still loading
	   it would show a dark gray rectangle. */
	/* For some reason the \`<img/>\` is not stretched to 100% width and height
	   and sometime there can be seen white pixels of the background at top and bottom. */
	background-color: var(--PhoneInputCountryFlag-backgroundColor--loading);
	/* Border is added via \`box-shadow\` because \`border\` interferes with \`width\`/\`height\`. */
	/* For some reason the \`<img/>\` is not stretched to 100% width and height
	   and sometime there can be seen white pixels of the background at top and bottom,
	   so an additional "inset" border is added. */
	-webkit-box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),
		inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);
	box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),
		inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);
}

.b7JYnNDHfql2e31qrcfA {
	/* Fixes weird vertical space above the flag icon. */
	/* https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/7#note_348586559 */
	display: block;
	/* 3rd party <SVG/> flag icons won't stretch if they have \`width\` and \`height\`.
	   Also, if an <SVG/> icon's aspect ratio was different, it wouldn't fit too. */
	width: 100%;
	height: 100%;
}

.zOD3ghJtwEzJDRGTQ4B9 {
	opacity: var(--PhoneInputInternationalIconPhone-opacity);
}

.ps8cFLFc3gnO8i0bUJfh {
	opacity: var(--PhoneInputInternationalIconGlobe-opacity);
}

/* Styling native country \`<select/>\`. */

.fZLwYoxYW0YkXh21h8U8 {
	position: relative;
	-ms-flex-item-align: stretch;
	align-self: stretch;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-right: var(--PhoneInputCountrySelect-marginRight);
}

.MUZmHqAFP9xzfbCIqlxy {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 1;
	border: 0;
	opacity: 0;
	cursor: pointer;
}

.MUZmHqAFP9xzfbCIqlxy[disabled],
.MUZmHqAFP9xzfbCIqlxy[readonly] {
	cursor: default;
}

.GHJOxJG2AmgKQZCsq6no {
	display: block;
	content: '';
	width: var(--PhoneInputCountrySelectArrow-width);
	height: var(--PhoneInputCountrySelectArrow-width);
	margin-left: var(--PhoneInputCountrySelectArrow-marginLeft);
	border-style: solid;
	border-color: var(--PhoneInputCountrySelectArrow-color);
	border-top-width: 0;
	border-bottom-width: var(--PhoneInputCountrySelectArrow-borderWidth);
	border-left-width: 0;
	border-right-width: var(--PhoneInputCountrySelectArrow-borderWidth);
	-webkit-transform: var(--PhoneInputCountrySelectArrow-transform);
	transform: var(--PhoneInputCountrySelectArrow-transform);
	opacity: var(--PhoneInputCountrySelectArrow-opacity);
}

.MUZmHqAFP9xzfbCIqlxy:focus + .Fst2Kt2IICGHH5VFs2Xa + .GHJOxJG2AmgKQZCsq6no {
	opacity: 1;
	color: var(--PhoneInputCountrySelectArrow-color--focus);
}

.MUZmHqAFP9xzfbCIqlxy:focus + .TB2QPWXJ6fToD3uCXjC0 {
	-webkit-box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),
		inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);
	box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),
		inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);
}

.MUZmHqAFP9xzfbCIqlxy:focus + .Fst2Kt2IICGHH5VFs2Xa .ps8cFLFc3gnO8i0bUJfh {
	opacity: 1;
	color: var(--PhoneInputCountrySelectArrow-color--focus);
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PhoneInput": `DWXlZA4qJECCe03PnK8T`,
	"PhoneInputInput": `C92DdxhbHyjHpBwTDvGU`,
	"PhoneInputCountryIcon": `Fst2Kt2IICGHH5VFs2Xa`,
	"PhoneInputCountryIcon--square": `NCiLa8ZsrVsUC76LuiWY`,
	"PhoneInputCountryIcon--border": `TB2QPWXJ6fToD3uCXjC0`,
	"PhoneInputCountryIconImg": `b7JYnNDHfql2e31qrcfA`,
	"PhoneInputInternationalIconPhone": `zOD3ghJtwEzJDRGTQ4B9`,
	"PhoneInputInternationalIconGlobe": `ps8cFLFc3gnO8i0bUJfh`,
	"PhoneInputCountry": `fZLwYoxYW0YkXh21h8U8`,
	"PhoneInputCountrySelect": `MUZmHqAFP9xzfbCIqlxy`,
	"PhoneInputCountrySelectArrow": `GHJOxJG2AmgKQZCsq6no`
};
export default ___CSS_LOADER_EXPORT___;
